<!-- 忘记密码重置密码功能模块 -->
<template>
  <div class="forgotPwd">
    <div class="top">
      <SvgIcon
        style="width: 40px; height: 40px;"
        :iconClass="'chevron-left'"
        @click="$router.back()"
      />
      忘记密码
    </div>
    <!-- 步骤条 -->
    <Steps
      style="width: 60%; margin: 0 auto"
      :stepList="stepList"
      :step="step"
    />
    <section style="margin-top: 60px">
      <!-- 第一步用户身份验证 -->
      <template v-if="step === 1">
        <VerifyCode
          style="width: 50%; margin: 0 auto"
          @submit="verifySubmit"
        />
      </template>
      <!-- 第二步重置密码 -->
      <template v-if="step === 2">
        <NewPwd
          style="width: 50%; margin: 0 auto"
          @submit="resetSubmit"
        />
      </template>
      <!-- 重置成功 -->
      <template v-if="step === 3">
        <div class="success-box">
          <div class="success-resetPwd">
            <SvgIcon
              style="width: 16px; height: 16px; margin-right: 10px;"
              :iconClass="'success'"
              @click="$router.back()"
            />
            <p>恭喜您，密码修改成功！</p>
          </div>
          <a-button
            class="success_btn"
            size="large"
            type="primary"
            @click="complete"
          >完成</a-button>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
import Steps from './Steps.vue'
import VerifyCode from './VerifyCode.vue'
import NewPwd from './NewPwd.vue'
import { resetPassword } from '@/api/forgotPwd'

export default {
  components: { SvgIcon, Steps, VerifyCode, NewPwd },
  data () {
    return {
      step: 1,
      stepList: [
        {
          title: '验证身份'
        },
        {
          title: '重置登录密码'
        },
        {
          title: '重置成功'
        }
      ],
      cacheData: {
        phoneNumber: '',
        resetToken: ''
      }
    }
  },
  methods: {
    /**
     * 验证码登录回调状态
     * @param { Object } params // 手机号&验证码
     */
    verifySubmit (params) {
      console.log(params, 'verifySubmit')
      const { mobile = '', resetToken = '' } = params
      this.cacheData.phoneNumber = mobile
      this.cacheData.resetToken = resetToken
      this.step = 2
    },
    /**
     * 重置密码回调状态
     * @param { Object } params // 重置密码
     */
    async resetSubmit (params) {
      console.log(params, 'resetSubmit')
      const { repPass = '' } = params
      const data = {
        password: repPass,
        ...this.cacheData
      }
      await resetPassword(data)
      this.step = 3
    },
    complete () {
      this.$router.push({ path: '/user/login' })
    }
  }
}
</script>

<style scoped lang="less">
.forgotPwd {
  width: 1200px;
  height: 596px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #dfe1e7;
  border-radius: 22px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .top {
    font-size: 34px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #303133;
    display: flex;
    align-items: center;
    padding: 30px 27px;
    cursor: pointer;
  }
  .success-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    .success-resetPwd {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      color: #84878d;
      margin-bottom: 30px;
      p {
        color: #84878d;
      }
    }
    .success_btn {
      width: 370px;
      height: 40px;
      background: #4b7dfd;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
